import React from 'react';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskRovoServiceAgent: LazyComponent<
	typeof import('@atlassian/jira-spa-apps-project-settings-service-desk-rovo-service-agent/src/ui/RovoServiceAgentView.tsx').default
> = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-rovo-service-agent", jiraSpaEntry: "async-project-settings-service-desk-rovo-service-agent" */ '@atlassian/jira-spa-apps-project-settings-service-desk-rovo-service-agent/src/ui/RovoServiceAgentView.tsx'
		),
	),
);

const ServicedeskRovoServiceAgentComponent = (): JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskRovoServiceAgent}
		pageId="project-settings-rovo-service-agent"
		shouldShowSpinner
	/>
);

export default ServicedeskRovoServiceAgentComponent;
